import React from 'react';
import { useStyletron } from 'baseui';
import { useSidePanel } from '../../side-panel/side-panel-provider';
import { AnnotationList } from './annotation-list';
export const AnnotationsPanel = () => {
  const [css, theme] = useStyletron();
  const {
    annotationFilterComponent
  } = useSidePanel();
  const sectionStyle = css({
    overflow: 'auto'
  });
  const titleStyle = css({
    paddingBottom: theme.sizing.scale300,
    ...theme.typography.LabelLarge
  });
  const contentStyle = css({
    paddingBottom: theme.sizing.scale400
  });
  return <div className={css({
    paddingTop: theme.sizing.scale800,
    display: 'flex',
    justifyContent: 'space-between',
    height: `calc(100% - ${theme.sizing.scale800})`,
    flexDirection: 'column'
  })}>
      <div className={sectionStyle}>
        {annotationFilterComponent && <div className={titleStyle}>{annotationFilterComponent()}</div>}
        <div className={contentStyle}>
          <AnnotationList />
        </div>
      </div>
    </div>;
};